import { ClearanceOutput } from 'enums';
import { messages } from 'i18n';

const { clearanceOutputLabels } = messages.submissionQueuePage;

const clearanceOutputConfig: Record<ClearanceOutput, string> = {
  [ClearanceOutput.Cleared]: clearanceOutputLabels.cleared,
  [ClearanceOutput.NotAppointed]: clearanceOutputLabels.notAppointed,
  [ClearanceOutput.Duplicate]: clearanceOutputLabels.duplicate,
};

export const getClearanceOutputLabel = (value: ClearanceOutput) => clearanceOutputConfig[value];
